
































































































































































































































































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { MangoPayUser } from '@/store/profile/types';
import { CreateBankAccountPayload, BankAccount } from '@/store/mangoPay/types';
import Modal from '@/components/_common/Modal.vue';
import ExporoSelect from '@/components/_common/Select.vue';
import { required, helpers } from 'vuelidate/lib/validators';
import { countryCodesArray } from '@/enum/CountryCodesEnum';

@Component({
  name: 'create-bank-account',
  components: {
    Modal,
    ExporoSelect,
  },
})
export default class CreateBankAccount extends Vue {

  @Action('mangoPay/fetchUserBankAccounts') fetchUserBankAccounts: Function;
  @Action('mangoPay/createBankAccount') createBankAccount: Function;

  @Getter('profile/mangoPayUser') mangoPayUser?: MangoPayUser;
  @Getter('profile/fullName') fullName?: string;
  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;

  isLoading: Boolean = false;
  error: string = '';
  bicError: string = '';
  ibanError: string = '';

  checkedOptions: Array<string> = [];
  formData: CreateBankAccountPayload = this.prefillForm();

  mounted() {
    this.formData = this.prefillForm();

    this.$v.$touch();
  }

  onCreateSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return null;
    }

    this.error = '';
    this.isLoading = true;

    const payload = { ...this.formData };

    if (!payload.OwnerAddress.Region) {
      delete payload.OwnerAddress.Region;
    }

    if (this.duplicatedAccount) {
      this.error = this.$t('bankAccount.warning', { context: 'duplicatedIBAN' });

      return false;
    }

    return this.createBankAccount(payload)
      .then(this.onCreateSuccess)
      .catch((error: any) => {
        this.error = error.response?.data.errors
          ? `${this.$t('forms.error', { context: 'invalidFields' })} ${Object.keys(
            error.response.data.errors,
          )}`
          : this.$t('forms.error', { context: 'generic' });
      })
      .finally(() => (this.isLoading = false));
  }

  get duplicatedAccount() {
    return this.bankAccounts.find(account =>
      account.IBAN === this.formData.IBAN &&
      account.Active
    );
  }

  async onCreateSuccess(data: any) {
    await this.fetchUserBankAccounts();

    this.$router.push(`/bank-account/${data.Id}`);
  }

  prefillForm(): CreateBankAccountPayload {
    return {
      OwnerName: this.fullName ? this.fullName : '',
      OwnerAddress: this.mangoPayUser
        ? this.mangoPayUser.Address
        : {
          AddressLine1: '',
          AddressLine2: '',
          City: '',
          Region: '',
          PostalCode: '',
          Country: '',
        },
      IBAN: '',
      BIC: '',
    };
  }

  validations() {
    return {
      formData: {
        OwnerName: { required },
        OwnerAddress: {
          AddressLine1: { required },
          AddressLine2: { required },
          City: { required },
          Region: {},
          PostalCode: { required },
          Country: { required },
        },
        IBAN: { 
          required,
          format(value)  {
            const basicIbanFormat = RegExp(/^[A-Z]{2}(?:[ ]?[A-Z0-9]){14,30}$/, 'g');

            return basicIbanFormat.test(value);
          },
        },
        BIC: { required,
          format(value)  {
            const mangoPayRegex = RegExp(/^[a-zA-Z]{6}\w{2}(\w{3})?$/, 'g');

            return mangoPayRegex.test(value);
          },
        },
      },
    };
  }

  get canSubmit() {
    return !this.isLoading && this.hasAgreed && !this.$v.$invalid;
  }

  get hasAgreed() {
    return this.checkedOptions.length > 0;
  }

  get countries() {
    return countryCodesArray.map(country => {
      return { name: country.name, value: country.isoAlpha2 };
    });
  }

  validateIBAN(e) {
    const { value } = e.target;

    if (!this.$v.formData.IBAN.$invalid) {

      this.isLoading = true;

      axios.get(`${process.env.VUE_APP_IBAN_VALIDATOR}/${value}?getBIC=true`)
        .then(({ data }) => {
          if (data.bankData.bic) {
            this.formData.BIC = data.bankData.bic;
            this.ibanError = '';
            this.bicError ='';
          } else {
            this.ibanError = !data.valid ? this.$t('bankAccount.warning', { context: 'invalidIBAN' }) : '';
          }
        })
        .catch((error) => console.log(error))
        .finally(() => { this.isLoading = false; });
    }
  }

  onClose() {
    this.error = undefined;
  }
}
